import React, { FunctionComponent } from 'react';
import { CSSProp } from 'styled-components';

import * as styles from '../styles/ProgressBar.styles';

export const PROGRESS_WRAPPER__DIV = 'PROGRESS_WRAPPER__DIV';
export const PROGRESS_INDICATOR__DIV = 'PROGRESS_INDICATOR__DIV';

const MIN = 0;
const MAX = 100;

export interface ProgressBarProps {
  progress: number;
  className?: string;
  css?: CSSProp;
}

export const ProgressBar: FunctionComponent<ProgressBarProps> = (props: ProgressBarProps) => {
  const progress = Math.min(MAX, Math.max(MIN, props.progress));

  return (
    <div
      css={styles.progressBar}
      role="presentation"
      className={props.className}
      data-testid={PROGRESS_WRAPPER__DIV}
    >
      <div
        css={styles.progress}
        style={{ width: `${progress}%` }}
        data-testid={PROGRESS_INDICATOR__DIV}
      />
    </div>
  );
};
